import React from 'react'

import clsx from 'clsx'

import Review from 'components/Review'
import { REVIEW_FIELDS } from 'helpers/domain'

import classes from './ReviewsByField.module.scss'

/** @type {import("./types").default} */
const ReviewsByField = ({ gridIndex, gridSize, isMobileTablet, listing }) => {
  return (
    <ul className={clsx('ReviewsByField', classes.reviewFields)} data-testid="reviews-by-field">
      {REVIEW_FIELDS.map(field => {
        const { reviews } = listing
        return (
          <div
            key={`${listing.slug}${field.slug}-sticky`}
            className={clsx('ReviewsByField__StickyContent', classes.container)}
          >
            {isMobileTablet && gridIndex === 0 && (
              <div className={clsx(classes.label, classes[`label-grid-${gridSize}`])}>
                <div data-testid="reviews-by-field-sticky" className={classes.sticky}>
                  <span className={classes.stickyText}>{field.text}</span>
                </div>
              </div>
            )}
            <li key={`${listing.slug}${field.slug}`}>
              <div
                data-testid="reviews-by-field-label"
                className={clsx(classes.fieldText, gridSize === 2 && classes['fieldText-size-2'])}
              >
                {field.text}
              </div>
              <div className={classes.ratingContainer}>
                <Review.Rating
                  isMobileTablet={isMobileTablet}
                  data-testid={field.slug}
                  xs
                  rating={parseFloat(reviews.by_field[field.slug])}
                />
              </div>
            </li>
          </div>
        )
      })}
    </ul>
  )
}

export default ReviewsByField
